import { render, staticRenderFns } from "./OwnerNetworkPartnerView.vue?vue&type=template&id=5a5c745e&scoped=true"
import script from "./OwnerNetworkPartnerView.vue?vue&type=script&lang=js"
export * from "./OwnerNetworkPartnerView.vue?vue&type=script&lang=js"
import style0 from "./OwnerNetworkPartnerView.vue?vue&type=style&index=0&id=5a5c745e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c745e",
  null
  
)

export default component.exports